<template>
  <div class="editCommunity">
    <div class="bg_line"></div>

    <div class="editCommunity_main">
      <div class="editCommunity_main_item">
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">
            <span class="icon_notice">*</span> 区
            <span class="hidden">占位</span>域：
          </div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.areaId" placeholder="请选择区域">
              <el-option v-for="(item,index) in regionData" :key="index" :label="item.name" :value="item.areaId">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">
            <span class="icon_notice">*</span>商
            <span class="hidden">占位</span>圈：
          </div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.tradeAreaId" placeholder="请选择商圈" @visible-change="getTradeAreaList">
              <el-option v-for="(item,index) in tradAreaData" :key="index" :label="item.tradeAreaName"
                :value="item.tradeAreaId"></el-option>
            </el-select>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">
            <span class="icon_notice">*</span>小区名称：
          </div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.name" placeholder="请输入小区名称"></el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form1">
          <div class="editCommunity_main_item_form_label">
            地
            <span class="hidden">占位</span>址：
          </div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input placeholder="请输入详细地址" :disabled="true" v-model="communityInfo.address">
              <template slot="append">
                <div class="iconBox" @click="addAddressBtn">
                  <i class="iconfont icon-icon_zhoubianpeitao"></i>
                </div>
              </template>
            </el-input>
          </div>
        </div>
      </div>
      <div class="editCommunity_main_item">
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">小区均价：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.avgPrice"
              @input="communityInfo.avgPrice=communityInfo.avgPrice.replace(/[^\d.]/g,'')" placeholder="请输入小区均价">
              <span slot="suffix">元/㎡</span>
            </el-input>
            <span></span>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">规划栋数：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.builds"
              @input="communityInfo.builds=communityInfo.builds.replace(/[^\d.]/g,'')" placeholder="请输入规划栋数">
              <span slot="suffix">栋</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">规划户数：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.households"
              @input="communityInfo.households=communityInfo.households.replace(/[^\d.]/g,'')" placeholder="请输入规划户数">
              <span slot="suffix">户</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form1">
          <div class="editCommunity_main_item_form_label">
            <span class="icon_notice">*</span>建筑类型：
          </div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.architecturalType" placeholder="请选择建筑类型" multiple collapse-tags>
              <el-option v-for="(item,index) in buildTypeD" :key="index" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="editCommunity_main_item">
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">开发商：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.developers" placeholder="请输入开发商"></el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">物业公司：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.propertyCompany" placeholder="请输入物业公司"></el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">物业电话：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.propertyPhone" placeholder="请输入物业电话"></el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form1">
          <div class="editCommunity_main_item_form_label">物业费：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.propertyFee" placeholder="请输入物业费"></el-input>
          </div>
        </div>
      </div>
      <div class="editCommunity_main_item">
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">占地面积：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.areaCovered"
              @input="communityInfo.areaCovered=communityInfo.areaCovered.replace(/[^\d.]/g,'')" placeholder="请输入占地面积">
              <span slot="suffix">㎡</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">建筑总面积：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.buildingCovered"
              @input="communityInfo.buildingCovered=communityInfo.buildingCovered.replace(/[^\d.]/g,'')"
              placeholder="请输入建筑总面积">
              <span slot="suffix">㎡</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">绿化率：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.greenRate" placeholder="请输入建筑绿化率"></el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">容积率：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.volumeRate" placeholder="请输入建筑容积率"></el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">车位数量：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.parkingSpaces" placeholder="请输入车位数量">
              <span slot="suffix">个</span>
            </el-input>
          </div>
        </div>
      </div>
      <div class="editCommunity_main_item">
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">停车方式：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.parkingMode" collapse-tags multiple placeholder="请选择停车方式">
              <el-option v-for="(item,index) in parkingWay" :key="index" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">停车费：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.parkingFee"
              @input="communityInfo.parkingFee=communityInfo.parkingFee.replace(/[^\d.]/g,'')" placeholder="请输入停车费">
              <span slot="suffix">元/月</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">商业供电：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.commercialPowerFeeMode" placeholder="请选择商业供电">
              <el-option v-for="(item,index) in powerSupplyWay" :key="index" :label="item.valueDesc"
                :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">商业电费：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.commercialPowerFee"
              @input="communityInfo.commercialPowerFee=communityInfo.commercialPowerFee.replace(/[^\d.]/g,'')"
              placeholder="请输入商业电费">
              <span slot="suffix">元/度</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">民用供电：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.powerSupplyMode" placeholder="请选择民用供电">
              <el-option v-for="(item,index) in powerSupplyWay" :key="index" :label="item.valueDesc"
                :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="editCommunity_main_item">
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">民用电费：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.powerFee"
              @input="communityInfo.powerFee=communityInfo.powerFee.replace(/[^\d.]/g,'')" placeholder="请输入民用电费">
              <span slot="suffix">元/度</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">商业供水：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.commercialWaterFeeMode" placeholder="请选择商业供水">
              <el-option v-for="(item,index) in waterSupplyWay" :key="index" :label="item.valueDesc"
                :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">商业水费：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.commercialWaterFee"
              @input="communityInfo.commercialWaterFee=communityInfo.commercialWaterFee.replace(/[^\d.]/g,'')"
              placeholder="请输入商业水费">
              <span slot="suffix">元/吨</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">民用供水：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.waterSupplyMode" placeholder="请选择民用供水">
              <el-option v-for="(item,index) in waterSupplyWay" :key="index" :label="item.valueDesc"
                :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">民用水费：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.waterFee"
              @input="communityInfo.waterFee=communityInfo.waterFee.replace(/[^\d.]/g,'')" placeholder="请输入民用水费">
              <span slot="suffix">元/吨</span>
            </el-input>
          </div>
        </div>
      </div>
      <div class="editCommunity_main_item">
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">商业供气：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.commercialGasFeeMode" placeholder="请选择商业供气">
              <el-option v-for="(item,index) in gasSupplyWay" :key="index" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">商业气费：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.commercialGasFee" placeholder="请输入商业气费">
              <span slot="suffix">元/m³</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">民用供气：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.gasSupplyMode" placeholder="请选择民用供气">
              <el-option v-for="(item,index) in gasSupplyWay" :key="index" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">民用气费：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.gasFee" placeholder="请输入民用气费">
              <span slot="suffix">元/m³</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form"></div>
      </div>
      <div class="editCommunity_main_item">
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">商业供暖：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.commercialWarmFeeMode" placeholder="请选择商业供暖">
              <el-option v-for="(item,index) in heatingWay" :key="index" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">商业暖气费：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.commercialWarmFee"
              @input="communityInfo.commercialWarmFee=communityInfo.commercialWarmFee.replace(/[^\d.]/g,'')"
              placeholder="请输入商业暖气费">
              <span slot="suffix">元/㎡/天</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">民用供暖：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-select v-model="communityInfo.warmSupplyModel" placeholder="请选择民用供暖">
              <el-option v-for="(item,index) in heatingWay" :key="index" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="editCommunity_main_item_form">
          <div class="editCommunity_main_item_form_label">民用暖气费：</div>
          <div class="editCommunity_main_item_form_ipt">
            <el-input v-model="communityInfo.warmFee"
              @input="communityInfo.warmFee=communityInfo.warmFee.replace(/[^\d.]/g,'')" placeholder="请输入民用暖气费">
              <span slot="suffix">元/㎡/天</span>
            </el-input>
          </div>
        </div>
        <div class="editCommunity_main_item_form"></div>
      </div>
      <div class="editCommunity_main_item">
        <div class="editCommunity_main_item_form_label">楼盘介绍：</div>
        <div class="editCommunity_main_item_form_ipt">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请输入楼盘介绍"
            v-model="communityInfo.description"></el-input>
        </div>
      </div>
    </div>

    <div class="footer_btn_wrap">
      <el-button class="remove_btn" @click="removeSaveBtn">取消</el-button>
      <el-button @click="saveCommunityBtn" v-points>保存</el-button>
    </div>

    <el-dialog title="标注地址" width="1000px" :visible.sync="dialogVisible" v-if="dialogVisible">
      <AddressAlert :regionName="rName" :addressAreaName="aName" :communityName="communiName"
        :curaddress="communityInfo.address" v-on:AddAlertremoveBtn="elDialogRemove" v-on:AddAlertSaveBtn="elDialogSave">
      </AddressAlert>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
// import MapLoader from '@/common/js/amap.js'
import { communityDetail, communityUpdate } from "@/api/manageCenter.js";
import AddressAlert from "@/components/common/addressAlert";
import Community from "@/mixins/Community";

export default {
  name: "add_community_wrap",
  mixins: [Community],
  data() {
    return {};
  },
  components: {
    AddressAlert
  },
  mounted() {
    this.getBuilding();
  },
  methods: {
    getAddress() {
      let parm = {
        uid: "8ee4560cf91d160e6cc02cd7",
        scope: 1,
        ak: "oauMIpiEgLdsuIYoKkUB8KkLRbE4VsSg"
      };
      this.$get(
        "http://api.map.baidu.com/place/v2/detail?uid=435d7aea036e54355abbbcc8&output=json&scope=2&ak=oauMIpiEgLdsuIYoKkUB8KkLRbE4VsSg",
        parm
      ).then(res => {});
    },
    getBuilding() {
      // 查询小区详情
      let id = sessionStorage.getItem("residentialAreaId");
      let params = {
        residentialAreaId: id
      };
      this.$post(communityDetail, params).then(res => {
        if (res.success) {
          this.communityInfo = Object.assign({}, res.data);
          this.communityInfo.oldAreaId = res.data.areaId;
          this.communityInfo.oldTradeAreaId = res.data.tradeAreaId;
          this.communityInfo.oldName = res.data.name;
          this.communityInfo.oldAvgPrice = res.data.avgPrice;
          this.communityInfo.oldAddress = res.data.address;
          this.getTradeAreaList(true);
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    // 保存按钮
    saveCommunityBtn() {
      if (!this.communityInfo.areaId) {
        this.$message.error("区域不能为空");
        return;
      } else if (!this.communityInfo.tradeAreaId) {
        this.$message.error("商圈不能为空");
        return;
      } else if (!this.communityInfo.name) {
        this.$message.error("小区名称不能为空");
        return;
      } else if (this.communityInfo.architecturalType.length==0) {
        this.$message.error("建筑类型不能为空");
        return;
      } 
      let params = this.communityInfo;
      this.$post(communityUpdate, params).then(res => {
        if (res.success) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          // this.$store.commit('delete_tabs', this.$route.path)
          this.$store.commit("delete_tabs", this.$route.path);
          sessionStorage.setItem("communitydelet", "del");
          this.$router.push({ path: "/CommunityDetail" });
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    // 取消保存
    removeSaveBtn() {
      this.$store.commit("delete_tabs", this.$route.path);
      this.$router.push({ path: "/CommunityList" });
    },
    // 调用地图选择地址
    addAddressBtn() {
      this.communiName = this.communityInfo.areaName;
      this.dialogVisible = true;
    },
    elDialogRemove() {
      this.dialogVisible = false;
    },
    elDialogSave(data) {
      //cosole.log(data);
      this.communityInfo.address = data.address;
      this.communityInfo.longitude = data.lng;
      this.communityInfo.latitude = data.lat;
      this.dialogVisible = false;
    }
  }
};
</script>
<style type="text/css" lang="less">
.editCommunity {
  display: block !important;
  background: #ffffff !important;
  margin: 14px;
  .hidden {
    visibility: hidden;
  }
  .icon_notice {
    color: #f64e4e;
  }
  &_main {
    padding: 26px 180px 26px 26px;
    &_item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-bottom: 42px;
      &_form {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        &_label {
          font-size: 14px;
          color: #333333;
          width: 100px;
          text-align: right;
        }
        &_ipt {
          flex: 1;
        }
      }
      &_form1 {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex: 2;
        &_label {
          font-size: 14px;
          color: #333333;
          min-width: 100px;
          text-align: right;
        }
        &_ipt {
          flex: 1;
        }
      }
      .el-input {
        width: 100% !important;
        .el-input {
          width: 100%;
        }
        .el-input__inner {
          width: 100%;
          height: 30px !important;
          line-height: 30px;
          border: 1px solid #dcdfe6;
        }
        .el-input__suffix {
          line-height: 30px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-style: normal;
          font-weight: 400;
          color: #333;
          .el-input__suffix-inner {
          }
        }
      }
      .el-select {
        width: 100% !important;
        .el-input {
          width: 100%;
        }
        .el-input__inner {
          width: 100%;
          height: 30px;
          border: 1px solid #dcdfe6;
        }
      }
      .el-date-editor {
        width: 100% !important;
        .el-input {
          width: 100%;
        }
        .el-input__inner {
          width: 100%;
          height: 30px;
          border: 1px solid #dcdfe6;
        }
      }
    }
  }

  .footer_btn_wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 50px;
    margin-bottom: 20px;
    margin-right: 100px;

    .el-button {
      width: 80px;
      height: 40px;
      background: #5e75e5;
      color: white;
      font-size: 16px;
      margin-left: 20px;

      &.remove_btn {
        background: #bbb;
      }
    }
  }
}
</style>
